type PageScrollJumpButtonsProps = {
  /** When false, renders nothing. */
  enabled?: boolean
}

const scrollShellMain = (edge: 'start' | 'end') => {
  const main = document.querySelector<HTMLElement>('.market-shell__main')
  if (main) {
    main.scrollTo({
      top: edge === 'start' ? 0 : main.scrollHeight,
      behavior: 'smooth',
    })
    return
  }
  window.scrollTo({
    top: edge === 'start' ? 0 : document.documentElement.scrollHeight,
    behavior: 'smooth',
  })
}

/** Fixed ↑/↓ controls to jump to the top or bottom of the scrollable shell. */
export const PageScrollJumpButtons = ({ enabled = true }: PageScrollJumpButtonsProps) => {
  if (!enabled) {
    return null
  }

  return (
    <div className="market-page-scroll-jumps" role="navigation" aria-label="Быстрая прокрутка страницы">
      <button
        type="button"
        className="market-page-scroll-jumps__btn"
        aria-label="Вверх страницы"
        title="Вверх страницы"
        onClick={() => scrollShellMain('start')}
      >
        ↑
      </button>
      <button
        type="button"
        className="market-page-scroll-jumps__btn"
        aria-label="Вниз страницы"
        title="Вниз страницы"
        onClick={() => scrollShellMain('end')}
      >
        ↓
      </button>
    </div>
  )
}

type TableScrollJumpProps = {
  direction: 'down' | 'up'
  targetId: string
}

/** Inline jump control placed above/below a long table. */
export const TableScrollJump = ({ direction, targetId }: TableScrollJumpProps) => {
  const handleClick = () => {
    const target = document.getElementById(targetId)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: direction === 'down' ? 'end' : 'start' })
      return
    }
    scrollShellMain(direction === 'down' ? 'end' : 'start')
  }

  return (
    <div className="market-table-scroll-jump">
      <button
        type="button"
        className="echat-btn echat-btn--ghost echat-btn--sm market-table-scroll-jump__btn"
        onClick={handleClick}
        aria-label={direction === 'down' ? 'К концу таблицы' : 'К началу таблицы'}
      >
        {direction === 'down' ? '↓ К концу таблицы' : '↑ К началу таблицы'}
      </button>
    </div>
  )
}
